import { render, staticRenderFns } from "./PaytMeth.vue?vue&type=template&id=33163f6c&"
import script from "./PaytMeth.vue?vue&type=script&lang=js&"
export * from "./PaytMeth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports